"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GroupController_js_1 = require("./GroupController.js");
exports.GroupController = GroupController_js_1.GroupController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/group/controllers/index.ts
// module id = 479
// module chunks = 0